import { addToEffectsMiddleware } from 'redux/utils/effectsMiddleware.util';
import { getUsersByIds } from '../thunks/users.thunk';
import { getClientById } from './clientSlice.slice';
import { getExpiringAndNeedsActionUserNeedsForGuideSuccess } from './needs.slice';
import { getMemberInfo } from './memberSliceActions.thunk';
import { selectMembersMap } from './memberSliceSelectors.util';
import { selectMember } from './selectedMemberSlice.slice';

export const registerMemberEffects = () => {
  addToEffectsMiddleware(addEffect => {
    addEffect({
      action: selectMember,
      effect: async ({ dispatch, action }) => {
        if (action.payload) {
          void dispatch(getMemberInfo({ params: { memberId: action.payload } }));
        }
      },
    });
    addEffect({
      action: getMemberInfo.fulfilled,
      effect: async ({ dispatch, action }) => {
        if (action.payload) {
          dispatch(getClientById({ params: { id: action.payload.clientId } }));
        }
      },
    });
    addEffect({
      action: getExpiringAndNeedsActionUserNeedsForGuideSuccess,
      effect: async ({ dispatch, action, state }) => {
        if (!action.payload || action.payload.length === 0) return;

        const memberMap = selectMembersMap(state);
        const missingMemberIds = action.payload
          .map(need => need.memberId)
          .filter(memberId => memberId)
          .filter(memberId => !memberMap[memberId])
          .filter((id, index, self) => self.indexOf(id) === index);

        if (missingMemberIds.length > 0) {
          void dispatch(getUsersByIds({ params: { ids: missingMemberIds } }));
        }
      },
    });
  });
};
